import { Alert, Button, Result, Spin } from 'antd';
import { Link, Navigate, useLocation } from 'react-router-dom';
import PageTitle from 'components/page-title';
import { STUDIO_PAGES, useStudioViewer } from './api';
import { describeStudioError } from './studio-error';
import { NO_STUDIO_TEXT, NO_STUDIO_TITLE, STUDIO_ERROR_TEXT } from './labels';
import styles from './styles.module.scss';

/**
 * `/studio` — "Studio của tôi" (SPEC Studio mục 8.1): gọi GET /studios/mine rồi chuyển hướng.
 * Có `studio` → `/studio/<id>` (giữ nguyên `?tab=` và tham số khác); `canViewAll` (Admin, SMOD) → `/studios`;
 * còn lại → màn "Bạn chưa được giao Studio nào".
 */
const StudioMinePage = () => {
  const location = useLocation();
  const { loading, error, mine, reload } = useStudioViewer();

  if (loading && !mine) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (error && !mine) {
    const view = describeStudioError(error);
    if (view.kind === 'unavailable') {
      return <Result status="warning" title={view.message} />;
    }
    return (
      <div className={styles.page}>
        <PageTitle title="Studio của tôi" />
        <Alert
          type="error"
          showIcon
          message={view.message}
          action={
            <Button size="small" onClick={reload}>
              Thử lại
            </Button>
          }
        />
      </div>
    );
  }

  if (mine?.studio) {
    return <Navigate to={`${STUDIO_PAGES.detail(mine.studio.id)}${location.search}`} replace />;
  }
  if (mine?.canViewAll) {
    return <Navigate to={STUDIO_PAGES.list} replace />;
  }

  return (
    <Result
      status="info"
      title={NO_STUDIO_TITLE}
      subTitle={
        mine?.kind === 'OPS_NO_STUDIO' ? STUDIO_ERROR_TEXT.STUDIO_NOT_MANAGER : NO_STUDIO_TEXT
      }
      extra={
        <Link to="/">
          <Button>Về Tổng quan</Button>
        </Link>
      }
    />
  );
};

export default StudioMinePage;
